import { useTranslation } from 'next-i18next';
import { cn } from '@/utils/tailwind.util';
import { QuizIndicatorChip } from './QuizIndicatorChip';
interface QuizSpacingRuleProps {
  ignoreSpaces?: boolean | null;
  onClick?: () => void;
  className?: string;
}

/**
 * QuizSpacingRule - 채점 기준 표시 컴포넌트
 * @component
 */
export const QuizSpacingRule = ({
  ignoreSpaces,
  onClick,
  className
}: QuizSpacingRuleProps) => {
  const {
    t
  } = useTranslation(['common']);
  if (ignoreSpaces !== false) {
    return null;
  }
  return <div className={cn('flex items-center gap-xs', onClick && 'cursor-pointer', className)} onClick={onClick} data-sentry-component="QuizSpacingRule" data-sentry-source-file="QuizSpacingRule.tsx">
      <QuizIndicatorChip className="shrink-0" data-sentry-element="QuizIndicatorChip" data-sentry-source-file="QuizSpacingRule.tsx">
        {t('common:quizItem.spacingRule.title')}
      </QuizIndicatorChip>
      <span className="grow break-all text-body-lg-medium text-alternative">
        {t('common:quizItem.spacingRule.description')}
      </span>
    </div>;
};